<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="4">
					<search-input
						:label="getMessage_('QWCC000956')"
						paramKey="partNo"
						@commInput="setSearchParam"
						@keyup.native.delete="() => onPartNoPutKeyDown()"
						:clearable="false"
						:propData="searchParams.partNo"
					>
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPartDtlPopup"></i></template>
					</search-input>
				</el-col>
				<!-- 검사번호 -->
				<el-col :span="4">
					<sf-input-group :label="getMessage_('QWCC000005')" :inputValue="searchParams.ckuNo" :disabled="true" />
				</el-col>
				<!-- 바코드 -->
				<el-col :span="4">
					<!-- <sf-input-group :label="getMessage_('QWCC001828')" v-bind="searchParams.bcdLblId" @commInput="setSearchParam" /> -->
					<sf-input-group
						ref="bcdLblIdInput"
						:label="getMessage_('QWCC001828')"
						:elProps="{ maxlength: 100 }"
						:inputValue="searchParams.bcdLblId"
						:onChange="value => onChangeBcdLbId(value)"
						@keyup.enter.native="onChangeAndShowBcdLbId()"
					/>
				</el-col>
				<!-- 바코드 품번 -->
				<el-col :span="4">
					<!-- <sf-input-group :label="getMessage_('QWCC001828')" v-bind="searchParams.bcdLblId" @commInput="setSearchParam" /> -->
					<search-input
						id="bcdPartNoInput"
						:label="getMessage_('QWCC001867')"
						paramKey="bcdPartNo"
						@commInput="onChangeBcdPartNo"
						:clearable="false"
						:propData="searchParams.bcdPartNo"
						@keyup.enter.native="() => barcodeCheckAction2()"
					>
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPartPopup"></i></template>
					</search-input>

					<!-- 품번 -->
					<!-- <search-input
						:label="getMessage_('QWCC000956') + ' / ' + getMessage_('QWCC000957')"
						paramKey="partNo"
						@commInput="setSearchParam"
						:clearable="false"
						:propData="searchParams.partNo"
					>
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPartPopup"></i></template>
					</search-input> -->

					<!-- <sf-input-group
						:label="getMessage_('QWCC001867')"
						:elProps="{ maxlength: 50 }"
						:inputValue="searchParams.bcdPartNo"
						:onChange="value => setSearchParam({ key: 'bcdPartNo', value })"
						@keyup.enter.native="barcodeCheckAction2"
					/> -->
				</el-col>
				<!-- Reverse(역순) -->
				<el-col :span="3">
					<!-- <div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">&nbsp;</span> -->
					<sf-group-wrapper :label="getMessage_('\u00A0')">
						<el-checkbox @input="value => onCheck('ckdYn', value)" >{{ getMessage_('QWCC002015') }}</el-checkbox>
					</sf-group-wrapper>
					<!-- </div> -->
				</el-col>
				<el-col :span="3">
					<sf-group-wrapper :label="getMessage_('\u00A0')">
						<el-checkbox @input="value => onCheck('speYn', value)" v-if="isButton_(scrId, 'IP') || isButton_(scrId, 'CS')">{{ getMessage_('QWCC001884') }}</el-checkbox>
					</sf-group-wrapper>
					<!-- </div> -->
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>

		<!-- 조회 공통팝업 -->
		<part-mng-popup ref="partMngPopup" @SendData="partMngData" :scrId="scrId"></part-mng-popup>
		<part-dtl-poupup ref="partDtlPoupup" @SendData="sendData" :scrId="scrId" />
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PartCku/store/helpers';
// import SelectCombo from '@qms/Components/SelectCombo';
import SearchInput from '@qms/Components/SearchInput';
import { utils } from '@sfaas/util';
import PartMngPopup from '@qms/comm/commpopup/PartMngPopup/PartMngPopup.vue';
import PartDtlPoupup from '@qms/pqy/pcku/PartCku/Content/Popup/PartDtlPopupContent.vue';
export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return { searchDateRange: [], isGlims: false };
	},
	components: { SearchInput, PartDtlPoupup, PartMngPopup },
	created() {
		this.getPartCkuInfo_(this.searchParams);
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setSearchParam(param) {
			// console.log(param);
			this.setSearchParam_(param);
		},
		onPartDtlPopup() {
			this.$refs.partDtlPoupup.open(this.searchParams.partNo);
		},
		onPartPopup() {
			this.$refs.partMngPopup.open(this.searchParams.bcdPartNo);
		},
		async searchList() {
			try {
				this.setSearchParam_({ key: 'bcdLblId', value: '' }); //바코드 초기화
				this.setSearchParam_({ key: 'bcdPartNo', value: '' }); //바코드품번 초기화

				if (this.searchParams.partNo === '') {
					throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001754'))); // 조회조건의 부품번호를 입력해 주시기 바랍니다.
				}

				this.$sf_toggleLoading(true);
				await this.getPartCkuInfo_(this.searchParams);
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error.message || error
				});
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		onChangeBcdLbId(payload){
			this.setSearchParam_({key: 'bcdLblId', value: payload});
		},
		onChangeAndShowBcdLbId(){

			let bcdLblIdArr = this.searchParams.bcdLblId.split(' ');
			let bcdLblId = '';
			if (bcdLblIdArr.length > 1) {
				bcdLblId = bcdLblIdArr[bcdLblIdArr.length - 1].trim();
			} else {
				bcdLblId = bcdLblIdArr[0].trim();
			}
			this.setSearchParam_({ key: 'bcdLblId', value: bcdLblId });

			let arrVal = bcdLblId.split(''); // ==> ascii값으로 29가 나온다.
			
			let cYn = this.searchParams.ckdYn;
			let bcdPartNo = this.searchParams.bcdPartNo;
			let partNo = '';
			let eoNo = '';
			let lotFromNo = '';
			let lotToNo = '';
			let cutLength = 9;
			// console.log('-----------', cYn);
			try {
				// if (cYn !== 'Y') {
				if (arrVal.length > 1) {
					//case 1번  아스키 코드가 있을경우
					// console.log('bcdLblId ::: ', bcdLblId, arrVal);
					arrVal.forEach(codeData => {
						// console.log('codeData ::: ' + codeData);
						if (codeData.startsWith('V')) {
							//V로시작하는 항목은 업체코드
							cofCd = codeData.substring(1, codeData.length);
							this.setSearchParam_({ key: 'cofCd', value: cofCd });
						} else if (codeData.startsWith('P')) {
							//P로시작하는 항목은 부품번호
							partNo = codeData.substring(1, codeData.length);
							this.setSearchParam_({ key: 'partNo', value: partNo });
						} else if (codeData.startsWith('S')) {
							//S로시작하는 항목은 서열번호
							alcCd = codeData.substring(1, codeData.length);
							this.setSearchParam_({ key: 'alcCd', value: alcCd });
						} else if (codeData.startsWith('E')) {
							//E로시작하는 항목은 EO번호(Engineering Order Number)
							eoNo = codeData.substring(1, codeData.length);
							lotFromNo = eoNo;
							lotToNo = lotFromNo;
							this.setSearchParam_({ key: 'eoNo', value: eoNo });
						}
					});

					this.setSearchParam_({ key: 'lotFromNo', value: lotFromNo });
					this.setSearchParam_({ key: 'lotToNo', value: lotToNo });
				} else {
					// ckd체크가 되어 있을경우 cutLength 를 기준으로 진행
					if (cYn === 'Y') {
						// if (utils.$sf_isNull(bcdPartNo) || bcdPartNo === '') {
						// 	// {0}는 필수입력 입니다. , 바코드 품번
						// 	throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001867')]));
						// }
						// partNo = bcdLblId.substring(10, 20);
						// lotFromNo = bcdLblId.substring(0, 10);
						let fromNo = this.searchParams.lotFromNo;
						let formFrNo = this.formInfo.lotFromNo;
						if(fromNo === undefined || fromNo === ''){
							lotFromNo = bcdLblId;
							this.onChangeParam_({key: 'lotFromNo', value: lotFromNo});
							this.setSearchParam_({ key: 'lotFromNo', value: lotFromNo });
							this.setSearchParam_({key: 'bcdLblId', value: ''});
							this.onChangeParam_({key: 'lotToNo', value: ''});
							this.setSearchParam_({key: 'lotToNo', value: ''});
						}else{
							lotToNo = bcdLblId;
							this.onChangeParam_({key: 'lotToNo', value: lotToNo});
							this.setSearchParam_({ key: 'lotToNo', value: lotToNo });
							if(formFrNo === undefined || formFrNo === ''){
								this.onChangeParam_({key: 'lotFromNo', value: fromNo});
							}
							// this.$nextTick(() => {
							// 	this.$refs.bcdPartNoInput.$refs.input.focus();
							// });
							// this.$refs.bcdPartNoInput.$refs.input.focus();
							// this.nextFocusOfBcd();
							document.querySelector('#bcdPartNoInput input').focus();
						}
						
					
					} else {
						// 앞자리 7자리 품번 뒷자리 9자리 lot번호
						// partNo = bcdLblId.substring(0, 7) + '000';
						// lotFromNo = bcdLblId.substring(bcdLblId.length - cutLength, bcdLblId.length);
						lotFromNo = bcdLblId;
						lotToNo = bcdLblId;
						this.onChangeParam_({key: 'lotFromNo', value: lotFromNo});
						this.onChangeParam_({key: 'lotToNo', value: lotFromNo});
						this.setSearchParam_({ key: 'lotFromNo', value: lotFromNo });
						this.setSearchParam_({ key: 'lotToNo', value: lotToNo });
						// this.$refs.bcdPartNoInput.$refs.input.focus();
						// this.$nextTick(() => {
						// 	this.$refs.bcdPartNoInput.$refs.input.focus();
						// });
						// this.nextFocusOfBcd();
						document.querySelector('#bcdPartNoInput input').focus();

					}

				}
				
					
			} catch (error) {
				this.$sf_toggleLoading(false);
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		sendData(params) {
			this.setSearchParam_({ key: 'partNo', value: params.partNo });
			this.setSearchParam_({ key: 'ckuNo', value: params.ckuNo });
		},
		partMngData(row) {
			this.setSearchParam_({ key: 'bcdPartNo', value: row.partNo });
		},
		onPartNoPutKeyDown() {
			this.setSearchParam_({ key: 'ckuNo', value: '' });
			this.setSearchParam_({ key: 'lotFromNo', value: '' });
		},
		onChangeBcdPartNo(param){
			// console.log('---------',param);
			this.setSearchParam_(param);
			if (param.value !== undefined && param.value.length === 10) {
				this.barcodeCheckAction2();	
			}
		},
		//바코드가 입력됐을때 확인
		async barcodeCheckAction(param) {
			this.setBarcodeSearchInit_(); //기본데이터 초기화
			this.$sf_toggleLoading(true);
			this.setSearchParam_({ key: 'partNo', value: '' });
			this.setSearchParam_({ key: 'ckuNo', value: '' });

			// let bcdLblIdArr = this.searchParams.bcdLblId.split(' ');
			// let bcdLblId = '';
			// if (bcdLblIdArr.length > 1) {
			// 	bcdLblId = bcdLblIdArr[bcdLblIdArr.length - 1].trim();
			// } else {
			// 	bcdLblId = bcdLblIdArr[0].trim();
			// }
			// this.setSearchParam_({ key: 'bcdLblId', value: bcdLblId });
			// console.log('bcdLblIdArr  bcdLblId  ::: ', bcdLblIdArr, bcdLblId);

			let bcdLblId = this.searchParams.bcdLblId;

			let cYn = this.searchParams.ckdYn;
			let sYn = this.searchParams.speYn; 
			let bcdPartNo = this.searchParams.bcdPartNo;
			let arrVal = bcdLblId.split(''); // ==> ascii값으로 29가 나온다.
			// console.log('arrVal.length >>> ', arrVal.length);
			let cofCd = this.searchParams.cofCd;
			let partNo = this.searchParams.partNo;
			let alcCd = this.searchParams.alcCd;
			let eoNo = this.searchParams.eoNo;
			let lotFromNo = this.searchParams.lotFromNo;
			let lotToNo = this.searchParams.lotToNo;
			let cutLength = -9;
			try {
				// if (cYn !== 'Y') {
				if (arrVal.length > 1) {
					//case 1번  아스키 코드가 있을경우
					// console.log('bcdLblId ::: ', bcdLblId, arrVal);
					// arrVal.forEach(codeData => {
					// 	// console.log('codeData ::: ' + codeData);
					// 	if (codeData.startsWith('V')) {
					// 		//V로시작하는 항목은 업체코드
					// 		cofCd = codeData.substring(1, codeData.length);
					// 	} else if (codeData.startsWith('P')) {
					// 		//P로시작하는 항목은 부품번호
					// 		partNo = codeData.substring(1, codeData.length);
					// 	} else if (codeData.startsWith('S')) {
					// 		//S로시작하는 항목은 서열번호
					// 		alcCd = codeData.substring(1, codeData.length);
					// 	} else if (codeData.startsWith('E')) {
					// 		//E로시작하는 항목은 EO번호(Engineering Order Number)
					// 		eoNo = codeData.substring(1, codeData.length);
					// 		lotFromNo = eoNo;
					// 		lotToNo = lotFromNo;
					// 	}
					// });
				} else {
					// ckd체크가 되어 있을경우 cutLength 를 기준으로 진행
					// if (cYn === 'Y') {
					// 	// if (utils.$sf_isNull(bcdPartNo) || bcdPartNo === '') {
					// 	// 	// {0}는 필수입력 입니다. , 바코드 품번
					// 	// 	throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001867')]));
					// 	// }
					// 	partNo = bcdLblId.substring(10, 20);
					// 	lotFromNo = bcdLblId.substring(0, 10);
					// } else {
					// 	// 앞자리 7자리 품번 뒷자리 9자리 lot번호
					// 	partNo = bcdLblId.substring(0, 7) + '000';
					// 	lotFromNo = bcdLblId.substring(bcdLblId.length - cutLength, bcdLblId.length);
					// }
					// lotToNo = lotFromNo;

					let barCodeParams = {
						bcdPartNo,
						partNo,
						lotFromNo,
						lotToNo,
						cofCd,
						cofNm: '',
						bcdLblId,
						sYn
					};

					const header = await this.getSearchBarcodeData_(barCodeParams);
					if (header.code !== 0) {
						this.$sf_toast({
							type: 'error',
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					} else {
						if (this.searchParams.ckuNo !== null && this.searchParams.ckuNo !== '') {
							this.searchList();
						}
					}
				}
			} catch (error) {
				this.$sf_toggleLoading(false);
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		// 바코드와 바코드 품번이 같이 입력 됐을때
		async barcodeCheckAction2() {
			this.setBarcodeSearchInit_(); //기본데이터 초기화
			this.setSearchParam_({ key: 'partNo', value: '' });
			this.setSearchParam_({ key: 'ckuNo', value: '' });

			try {
				let cutLength = -9;
				let bcdLblId = this.searchParams.bcdLblId;
				// let bcdPartNo = this.searchParams.bcdPartNo;

				let bcdPartNoArr = this.searchParams.bcdPartNo.split(' ');
				let bcdPartNo = '';
				if (bcdPartNoArr.length > 1) {
					bcdPartNo = bcdPartNoArr[bcdPartNoArr.length - 1].trim();
				} else {
					bcdPartNo = bcdPartNoArr[0].trim();
				}
				this.setSearchParam_({ key: 'bcdPartNo', value: bcdPartNo });

				// let cYn = this.searchParams.ckdYn;
				// let sYn = this.searchParams.speYn; 
				// let lotFromNo = bcdLblId.slice(cutLength);
				// let lotToNo = lotFromNo;
				// let partNo = '';

				let cYn = this.searchParams.ckdYn;
				let sYn = this.searchParams.speYn; 
				let arrVal = bcdLblId.split(''); // ==> ascii값으로 29가 나온다.
				// console.log('arrVal.length >>> ', arrVal.length);
				let cofCd = this.searchParams.cofCd;
				let partNo = this.searchParams.partNo;
				let alcCd = this.searchParams.alcCd;
				let eoNo = this.searchParams.eoNo;
				let lotFromNo = this.searchParams.lotFromNo;
				let lotToNo = this.searchParams.lotToNo;

				// console.log('cYn , bcdLblId, bcdPartNo, lotFromNo, lotToNo >>> ', cYn, bcdLblId, bcdPartNo, lotFromNo, lotToNo);

				if (utils.$sf_isNull(bcdPartNo) || bcdPartNo === '') {
					// {0}는 필수입력 입니다. , 바코드 품번
					throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001867')]));
				}

				if (utils.$sf_isNull(bcdLblId) || bcdLblId === '') {
					// {0}는 필수입력 입니다. , 바코드
					throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001828')]));
				}

				if (utils.$sf_isNull(lotFromNo) || lotFromNo === '') {
					// {0}는 필수입력 입니다. , 바코드
					throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001470')]));
				}

				if (utils.$sf_isNull(lotToNo) || lotToNo === '') {
					// {0}는 필수입력 입니다. , 바코드
					throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001469')]));
				}

				partNo = bcdPartNo;

				let barCodeParams = {
					bcdPartNo,
					partNo,
					cofCd,
					cofNm: '',
					bcdLblId,
					reverseYn: cYn,
					lotFromNo,
					lotToNo,
					sYn
				};
				const header = await this.getSearchBarcodeData_(barCodeParams);
				if (header.code !== 0) {
					this.$sf_toast({
						type: 'error',
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				} else {
					//console.log('this.searchParams.ckuNo >>> ', this.searchParams.ckuNo);
					if (this.searchParams.ckuNo !== null && this.searchParams.ckuNo !== '') {
						this.searchList();
					} else {
						this.onDataInit();
					}
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		onDataInit() {
			const ckuScnCd = this.formInfo.ckuScnCd;

			// 시리얼 일때
			if (ckuScnCd === 'S') {
				this.onChangeParam({ key: 'ckuQty', value: 1 });
				for (let i = 0; i < this.resultList.length; i++) {
					if (this.resultList[i].comboYn === 'Y') {
						this.resultList[i].x1 = 'OK';
					}
					this.resultList[i].x2 = null;
					this.resultList[i].x3 = null;
					this.resultList[i].x4 = null;
					this.resultList[i].x5 = null;
					this.resultList[i].x6 = null;
					this.resultList[i].x7 = null;
					this.resultList[i].x8 = null;
					this.resultList[i].x9 = null;
					this.resultList[i].x10 = null;
				}
			}
		},
		onChangeParam(payload) {
			this.$sf_toggleLoading(true);
			this.onChangeParam_(payload)
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => this.$sf_toggleLoading(false));
		},
		onCheck(key, value) {
			// console.log(value);
			if (value) {
				this.setSearchParam_({ key, value: 'Y' });
			} else {
				this.setSearchParam_({ key, value: 'N' });
			}
			// this.onChangeAndShowBcdLbId();
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
